import { Box, Container, Stack, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const isItems: ReadonlyArray<string> = [
  'Staying on track with your growth through structured, supportive accountability.',
  'Collaborating on individualized growth targets tailored to your unique situation.',
  'Strengthening both personal and professional skills to foster real, lasting success.',
];

const isNotItems: ReadonlyArray<string> = [
  'Generic, cookie-cutter solutions copied from a playbook.',
  'Therapy — that work is valuable, but coaching focuses on leadership challenges.',
  'Someone dictating your next move. Coaching empowers; it does not prescribe.',
];

export function Approach() {
  return (
    <Box
      component="section"
      id="approach"
      sx={{ backgroundColor: 'background.default', py: { xs: 10, md: 14 } }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={2}
          sx={{ textAlign: 'center', alignItems: 'center', mb: { xs: 6, md: 8 } }}
        >
          <Typography variant="overline" sx={{ color: 'primary.main' }}>
            What is coaching?
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{ color: 'primary.dark', fontSize: { xs: '2rem', md: '2.7rem' }, maxWidth: 760 }}
          >
            Clear about what coaching is &mdash; and what it isn&rsquo;t.
          </Typography>
        </Stack>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 3, md: 5 },
          }}
        >
          {/* Coaching IS */}
          <Stack
            spacing={2.5}
            sx={{
              p: { xs: 4, md: 5 },
              backgroundColor: 'rgba(31, 61, 46, 0.05)',
              border: '1px solid rgba(31, 61, 46, 0.18)',
              borderRadius: 1.5,
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: 'primary.main', letterSpacing: '0.22em' }}
            >
              Coaching is
            </Typography>
            <Stack spacing={2.25}>
              {isItems.map((line) => (
                <Stack
                  key={line}
                  direction="row"
                  spacing={1.5}
                  sx={{ alignItems: 'flex-start' }}
                >
                  <Box
                    sx={{
                      mt: '2px',
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: 'primary.main',
                      color: 'primary.contrastText',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <CheckRoundedIcon sx={{ fontSize: 16 }} />
                  </Box>
                  <Typography variant="body1" sx={{ color: 'text.primary' }}>
                    {line}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>

          {/* Coaching IS NOT */}
          <Stack
            spacing={2.5}
            sx={{
              p: { xs: 4, md: 5 },
              backgroundColor: 'rgba(216, 196, 182, 0.18)',
              border: '1px solid rgba(31, 61, 46, 0.10)',
              borderRadius: 1.5,
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: 'text.secondary', letterSpacing: '0.22em' }}
            >
              Coaching is not
            </Typography>
            <Stack spacing={2.25}>
              {isNotItems.map((line) => (
                <Stack
                  key={line}
                  direction="row"
                  spacing={1.5}
                  sx={{ alignItems: 'flex-start' }}
                >
                  <Box
                    sx={{
                      mt: '2px',
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: 'rgba(31, 61, 46, 0.12)',
                      color: 'text.secondary',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <CloseRoundedIcon sx={{ fontSize: 16 }} />
                  </Box>
                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    {line}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
